(function () {
  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  const getOpenDialog = () => document.querySelector('[data-size-modal-dialog]:not([hidden])');

  const setPageLocked = (locked) => {
    document.documentElement.classList.toggle('drapeur-size-modal-open', locked);
    document.body.classList.toggle('drapeur-size-modal-open', locked);
  };

  const openModal = (root, trigger) => {
    const dialog = root.querySelector('[data-size-modal-dialog]');
    const overlay = root.querySelector('[data-size-modal-overlay]');
    const content = root.querySelector('[data-size-modal-content]');
    if (!dialog || !overlay) return;

    root._trigger = trigger;
    root._prevFocus = document.activeElement;
    overlay.hidden = false;
    dialog.hidden = false;
    dialog.scrollTop = 0;
    if (content) content.scrollTop = 0;
    trigger.setAttribute('aria-expanded', 'true');
    setPageLocked(true);

    window.requestAnimationFrame(() => {
      const closeButton = root.querySelector('[data-size-modal-close]');
      (closeButton || dialog).focus();
    });
  };

  const closeModal = (root) => {
    const dialog = root.querySelector('[data-size-modal-dialog]');
    const overlay = root.querySelector('[data-size-modal-overlay]');
    if (!dialog || !overlay) return;

    overlay.hidden = true;
    dialog.hidden = true;
    if (root._trigger) root._trigger.setAttribute('aria-expanded', 'false');
    setPageLocked(Boolean(getOpenDialog()));

    const returnTarget = root._trigger || root._prevFocus;
    if (returnTarget && typeof returnTarget.focus === 'function') returnTarget.focus();
  };

  document.addEventListener('click', function (event) {
    const openButton = event.target.closest('[data-size-modal-open]');
    const closeButton = event.target.closest('[data-size-modal-close]');
    const overlay = event.target.closest('[data-size-modal-overlay]');

    if (openButton) {
      event.preventDefault();
      const targetId = openButton.getAttribute('data-size-modal-target');
      const root = targetId && document.getElementById(targetId);
      if (root) openModal(root, openButton);
      return;
    }

    if (closeButton || overlay) {
      const root = event.target.closest('[data-size-modal]');
      if (root) closeModal(root);
      return;
    }

    const legacyLink = event.target.closest('a.open-size-guide');
    if (!legacyLink) return;

    event.preventDefault();
    const modalButton = document.querySelector('[data-size-modal-open]');
    if (modalButton) modalButton.click();
  });

  document.addEventListener('keydown', function (event) {
    const dialog = getOpenDialog();
    if (!dialog) return;

    const root = dialog.closest('[data-size-modal]');
    if (!root) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal(root);
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = Array.from(dialog.querySelectorAll(focusableSelector)).filter((element) => {
      return element.offsetParent !== null;
    });

    if (!focusable.length) {
      event.preventDefault();
      dialog.focus();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
